(function () {
  function getContractDocument() {
    return document.getElementById('oc-contrat-document');
  }

  function initContratActions() {
    const actions = document.getElementById('oc-contrat-actions');
    const documentContrat = getContractDocument();

    if (!actions || !documentContrat || actions.dataset.initialized === 'true') {
      return;
    }

    actions.dataset.initialized = 'true';

    const pdfUrl = (actions.dataset.pdfUrl || '').trim();

    actions.innerHTML = `
      <button type="button" class="oc-contrat-button" data-action="print-empty">
        Imprimer le contrat vierge
      </button>

      <button type="button" class="oc-contrat-button" data-action="print-filled">
        Imprimer ma version personnalisée
      </button>

      <button
        type="button"
        class="oc-contrat-button oc-contrat-button-secondary"
        data-action="download-pdf"
        disabled
      >
        Télécharger le PDF vierge
      </button>

      <button type="button" class="oc-contrat-button oc-contrat-button-secondary" data-action="reset">
        Réinitialiser
      </button>
    `;

    const pdfButton = actions.querySelector('[data-action="download-pdf"]');

    if (pdfButton && pdfUrl) {
      pdfButton.disabled = false;
    }

    actions.addEventListener('click', function (event) {
      const button = event.target.closest('[data-action]');

      if (!button) return;

      const action = button.dataset.action;

      if (action === 'print-empty') {
        printContrat(true);
      }

      if (action === 'print-filled') {
        printContrat(false);
      }

      if (action === 'download-pdf') {
        if (!pdfUrl) return;

        const link = document.createElement('a');

        link.href = pdfUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.download = 'contrat-de-chastete-gratuit.pdf';

        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      if (action === 'reset') {
        resetContrat();
      }
    });
  }

  function initContratOptions() {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    documentContrat
      .querySelectorAll('.oc-option[data-type]')
      .forEach(function (marker) {
        if (marker.dataset.initialized === 'true') return;

        const label = document.createElement('label');
        const input = document.createElement('input');
        const text = document.createElement('span');

        input.type = marker.dataset.type;
        input.name = marker.dataset.group || '';
        input.value = marker.dataset.value || '';
        input.className = 'oc-contrat-choice';

        if (marker.dataset.exclusive === 'true') {
          input.dataset.exclusive = 'true';
        }

        label.className = 'oc-contrat-option';
        text.className = 'oc-contrat-option-text';

        while (marker.firstChild) {
          text.appendChild(marker.firstChild);
        }

        label.appendChild(input);
        label.appendChild(text);
        marker.replaceWith(label);
      });
  }

  function initContratFields() {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    documentContrat
      .querySelectorAll('.oc-field[data-type="text"], .oc-field[data-type="textarea"]')
      .forEach(function (marker) {
        const fieldType = marker.dataset.type;
        const field = fieldType === 'textarea'
          ? document.createElement('textarea')
          : document.createElement('input');

        if (fieldType === 'textarea') {
          field.rows = Number.parseInt(marker.dataset.rows || '3', 10);
          field.className = 'oc-contrat-textarea';
        } else {
          field.type = 'text';
          field.className = 'oc-contrat-input';
        }

        field.name = marker.dataset.name || '';
        field.setAttribute('aria-label', marker.dataset.label || 'Champ à compléter');
        field.autocomplete = 'off';
        marker.replaceWith(field);
      });
  }

  function syncCompletedFields() {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    documentContrat
      .querySelectorAll('.oc-contrat-input, .oc-contrat-textarea')
      .forEach(function (field) {
        field.classList.toggle(
          'oc-field-complete',
          field.value.trim() !== ''
        );
      });
  }

  function initCompletedFields() {
    const documentContrat = getContractDocument();

    if (
      !documentContrat ||
      documentContrat.dataset.completedFieldsInitialized === 'true'
    ) {
      return;
    }

    documentContrat.dataset.completedFieldsInitialized = 'true';

    documentContrat.addEventListener('input', function (event) {
      const field = event.target;

      if (
        !(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)
      ) {
        return;
      }

      if (
        !field.classList.contains('oc-contrat-input') &&
        !field.classList.contains('oc-contrat-textarea')
      ) {
        return;
      }

      field.classList.toggle(
        'oc-field-complete',
        field.value.trim() !== ''
      );
    });

    syncCompletedFields();
  }

  function initExclusiveChoices() {
    const documentContrat = getContractDocument();

    if (!documentContrat || documentContrat.dataset.exclusiveInitialized === 'true') {
      return;
    }

    documentContrat.dataset.exclusiveInitialized = 'true';

    documentContrat.addEventListener('change', function (event) {
      const input = event.target;

      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox' || !input.name) {
        return;
      }

      const groupInputs = Array.from(
        documentContrat.querySelectorAll('input[type="checkbox"]')
      ).filter(function (otherInput) {
        return otherInput.name === input.name;
      });

      if (input.checked && input.dataset.exclusive === 'true') {
        groupInputs.forEach(function (otherInput) {
          if (otherInput !== input) otherInput.checked = false;
        });
      }

      if (input.checked && input.dataset.exclusive !== 'true') {
        groupInputs.forEach(function (otherInput) {
          if (otherInput.dataset.exclusive === 'true') {
            otherInput.checked = false;
          }
        });
      }
    });
  }

  function syncConditionalFields() {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    documentContrat
      .querySelectorAll('.oc-contrat-option')
      .forEach(function (option) {
        const choice = option.querySelector(':scope > .oc-contrat-choice');
        const fields = option.querySelectorAll(
          '.oc-contrat-input, .oc-contrat-textarea'
        );

        if (!choice) return;

        const isActive = choice.checked;
        option.classList.toggle('oc-option-active', isActive);
        option.classList.toggle('oc-option-inactive', !isActive);

        if (fields.length === 0) return;

        fields.forEach(function (field) {
          field.disabled = !isActive;
          field.setAttribute('aria-disabled', String(!isActive));

          if (!isActive && field.value !== '') {
            field.value = '';
          }
        });
      });

    syncCompletedFields();
  }

  function initConditionalFields() {
    const documentContrat = getContractDocument();

    if (!documentContrat || documentContrat.dataset.conditionalInitialized === 'true') {
      return;
    }

    documentContrat.dataset.conditionalInitialized = 'true';

    documentContrat.addEventListener('change', function (event) {
      const input = event.target;

      if (
        input instanceof HTMLInputElement &&
        (input.type === 'radio' || input.type === 'checkbox')
      ) {
        syncConditionalFields();
      }
    });

    syncConditionalFields();
  }

  function resetContrat() {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    const confirmed = window.confirm(
      'Réinitialiser toutes les cases et tous les champs du contrat ?'
    );

    if (!confirmed) return;

    documentContrat
      .querySelectorAll('input, textarea')
      .forEach(function (field) {
        if (
          field instanceof HTMLInputElement &&
          (field.type === 'checkbox' || field.type === 'radio')
        ) {
          field.checked = false;
        } else {
          field.value = '';
        }
      });

    syncConditionalFields();
  }

  function createPrintedChoice(sourceControl, emptyVersion) {
    const printedChoice = document.createElement('span');
    const isChecked = emptyVersion ? false : sourceControl.checked;

    printedChoice.className = 'oc-print-choice';
    printedChoice.setAttribute('aria-hidden', 'true');

    if (sourceControl.type === 'checkbox') {
      printedChoice.textContent = isChecked ? '☑' : '☐';
    } else {
      printedChoice.textContent = isChecked ? '●' : '○';
    }

    return printedChoice;
  }

  function createPrintedField(sourceControl, emptyVersion) {
    const printedField = document.createElement('span');
    const parentOption = sourceControl.closest('.oc-contrat-option');
    const associatedChoice = parentOption
      ? parentOption.querySelector(':scope > .oc-contrat-choice')
      : null;

    const optionIsActive = !associatedChoice || associatedChoice.checked;
    const value = emptyVersion || !optionIsActive
      ? ''
      : sourceControl.value.trim();

    if (sourceControl instanceof HTMLTextAreaElement) {
      printedField.className = 'oc-print-textarea';
    } else {
      printedField.className = 'oc-print-field';
    }

    if (value) {
      printedField.textContent = value;
      printedField.classList.add('has-value');
    } else {
      printedField.innerHTML = '&nbsp;';
      printedField.classList.add('is-empty');
    }

    return printedField;
  }

  function preparePrintClone(source, clone, emptyVersion) {
    const sourceControls = Array.from(source.querySelectorAll('input, textarea'));
    const cloneControls = Array.from(clone.querySelectorAll('input, textarea'));

    sourceControls.forEach(function (sourceControl, index) {
      const cloneControl = cloneControls[index];

      if (!cloneControl) return;

      if (
        sourceControl instanceof HTMLInputElement &&
        (sourceControl.type === 'checkbox' || sourceControl.type === 'radio')
      ) {
        cloneControl.replaceWith(
          createPrintedChoice(sourceControl, emptyVersion)
        );
        return;
      }

      cloneControl.replaceWith(
        createPrintedField(sourceControl, emptyVersion)
      );
    });

    clone
      .querySelectorAll('.oc-option-active, .oc-option-inactive')
      .forEach(function (option) {
        option.classList.remove('oc-option-active', 'oc-option-inactive');
      });
  }

  function copyStylesToPrintDocument(printDocument) {
    const loadingPromises = [];

    document
      .querySelectorAll('link[rel="stylesheet"], style')
      .forEach(function (sourceNode) {
        if (sourceNode.tagName === 'LINK') {
          const link = printDocument.createElement('link');

          link.rel = 'stylesheet';
          link.href = sourceNode.href;

          if (sourceNode.media) {
            link.media = sourceNode.media;
          }

          loadingPromises.push(
            new Promise(function (resolve) {
              let resolved = false;

              const finish = function () {
                if (resolved) return;
                resolved = true;
                resolve();
              };

              link.addEventListener('load', finish, { once: true });
              link.addEventListener('error', finish, { once: true });
              window.setTimeout(finish, 2500);
            })
          );

          printDocument.head.appendChild(link);
          return;
        }

        printDocument.head.appendChild(sourceNode.cloneNode(true));
      });

    return loadingPromises;
  }

  function addStandalonePrintStyles(printDocument) {
    const style = printDocument.createElement('style');

    style.textContent = `
      html,
      body {
        margin: 0 !important;
        padding: 0 !important;
        background: #eef1ef !important;
        color: #000000 !important;
      }

      body {
        font-family: Arial, Helvetica, sans-serif !important;
      }

      #oc-print-toolbar {
        position: sticky;
        top: 0;
        z-index: 1000;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
        border-bottom: 1px solid #d6dcd8;
        background: #ffffff;
      }

      #oc-print-toolbar button {
        appearance: none;
        border: 1px solid #2f4e40;
        border-radius: 4px;
        background: #2f4e40;
        color: #ffffff;
        cursor: pointer;
        font: inherit;
        padding: 11px 16px;
      }

      #oc-print-toolbar button.oc-print-close {
        background: transparent;
        color: #2f4e40;
      }

      #oc-print-toolbar button:disabled {
        border-color: #c9d0cc;
        background: #f3f5f4;
        color: #7a837e;
        cursor: wait;
      }

      #oc-print-status {
        flex-basis: 100%;
        margin: 0;
        color: #56635d;
        font-size: 13px;
        text-align: center;
      }

      #oc-contrat-print-root {
        position: static !important;
        top: auto !important;
        left: auto !important;
        display: block !important;
        width: calc(100% - 24px) !important;
        max-width: 210mm !important;
        height: auto !important;
        box-sizing: border-box;
        margin: 24px auto !important;
        padding: 14mm !important;
        pointer-events: auto !important;
        z-index: auto !important;
        background: #ffffff !important;
        color: #000000 !important;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
        font-size: 11pt !important;
        line-height: 1.45 !important;
      }

      #oc-contrat-print-root .oc-print-header {
        display: block !important;
        margin: 0 0 22px !important;
        text-align: center !important;
      }

      #oc-contrat-print-root .oc-print-logo {
        display: block !important;
        width: 280px !important;
        max-width: 60% !important;
        height: auto !important;
        margin: 0 auto 8px !important;
      }

      #oc-contrat-print-root .oc-print-title {
        margin: 0 !important;
        font-size: 20pt !important;
        font-weight: 500 !important;
        letter-spacing: 0.02em !important;
        text-align: center !important;
      }

      #oc-contrat-print-root .oc-web-contract-heading,
      #oc-contrat-print-root .oc-web-contract-instructions {
        display: none !important;
      }

      #oc-contrat-print-root .oc-contrat-document {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      #oc-contrat-print-root .oc-contrat-option {
        display: grid !important;
        grid-template-columns: 18px minmax(0, 1fr) !important;
        align-items: start !important;
        column-gap: 6px !important;
        width: 100% !important;
        margin: 1px 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        color: #000000 !important;
      }

      #oc-contrat-print-root .oc-print-choice {
        display: inline-block !important;
        width: 18px !important;
        font-family: Arial, sans-serif !important;
        font-size: 13pt !important;
        font-weight: 400 !important;
        line-height: 1 !important;
        text-align: center !important;
      }

      #oc-contrat-print-root .oc-print-field {
        display: inline-block !important;
        min-width: 130px !important;
        min-height: 1.25em !important;
        box-sizing: border-box !important;
        vertical-align: baseline !important;
        border-bottom: 1px solid #000000 !important;
        color: #000000 !important;
        line-height: 1.25 !important;
        padding: 0 4px 1px !important;
        white-space: pre-wrap !important;
        overflow-wrap: anywhere !important;
      }

      #oc-contrat-print-root .oc-contrat-option .oc-print-field {
        display: block !important;
        width: 100% !important;
        max-width: 280px !important;
        margin-top: 3px !important;
      }

      #oc-contrat-print-root .oc-print-textarea {
        display: block !important;
        width: 100% !important;
        min-height: 70px !important;
        box-sizing: border-box !important;
        border: 1px solid #000000 !important;
        color: #000000 !important;
        line-height: 1.4 !important;
        padding: 7px 9px !important;
        white-space: pre-wrap !important;
        overflow-wrap: anywhere !important;
      }

      #oc-contrat-print-root .oc-print-field.has-value,
      #oc-contrat-print-root .oc-print-textarea.has-value {
        font-weight: 500 !important;
      }

      @media print {
        @page {
          margin: 14mm;
        }

        html,
        body {
          background: #ffffff !important;
        }

        #oc-print-toolbar {
          display: none !important;
        }

        #oc-contrat-print-root {
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
        }

        #oc-contrat-print-root h2,
        #oc-contrat-print-root h3,
        #oc-contrat-print-root h4 {
          break-after: avoid !important;
          page-break-after: avoid !important;
        }

        #oc-contrat-print-root .oc-contrat-option {
          break-inside: avoid !important;
          page-break-inside: avoid !important;
        }
      }
    `;

    printDocument.head.appendChild(style);
  }

  function waitForPrintImages(printDocument) {
    return Array.from(printDocument.images).map(function (image) {
      if (image.complete) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        let resolved = false;

        const finish = function () {
          if (resolved) return;
          resolved = true;
          resolve();
        };

        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
        window.setTimeout(finish, 2500);
      });
    });
  }

  function printContrat(emptyVersion) {
    const documentContrat = getContractDocument();

    if (!documentContrat) return;

    /*
     * La nouvelle fenêtre doit être ouverte immédiatement pendant le clic.
     * C'est indispensable pour éviter le blocage de Safari sur iPhone.
     */
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      window.alert(
        "La page d'impression a été bloquée. Autorisez les fenêtres pop-up pour ce site, puis réessayez."
      );
      return;
    }

    const contractClone = documentContrat.cloneNode(true);

    contractClone.id = 'oc-contrat-document-print';
    preparePrintClone(documentContrat, contractClone, emptyVersion);

    const printDocument = printWindow.document;

    printDocument.open();
    printDocument.write(
      '<!doctype html><html lang="fr"><head>' +
        '<meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width, initial-scale=1">' +
        '<base href="' + document.baseURI.replace(/"/g, '&quot;') + '">' +
        '<title>Impression du contrat</title>' +
      '</head><body></body></html>'
    );
    printDocument.close();

    const stylePromises = copyStylesToPrintDocument(printDocument);

    addStandalonePrintStyles(printDocument);

    const toolbar = printDocument.createElement('div');
    const printButton = printDocument.createElement('button');
    const closeButton = printDocument.createElement('button');
    const status = printDocument.createElement('p');
    const printRoot = printDocument.createElement('div');

    toolbar.id = 'oc-print-toolbar';

    printButton.type = 'button';
    printButton.disabled = true;
    printButton.textContent = 'Préparation du contrat…';

    closeButton.type = 'button';
    closeButton.className = 'oc-print-close';
    closeButton.textContent = 'Fermer';

    status.id = 'oc-print-status';
    status.textContent =
      'Le contrat va apparaître ci-dessous. Utilisez ensuite le bouton pour imprimer ou enregistrer en PDF.';

    printRoot.id = 'oc-contrat-print-root';
    printRoot.appendChild(printDocument.importNode(contractClone, true));

    toolbar.appendChild(printButton);
    toolbar.appendChild(closeButton);
    toolbar.appendChild(status);

    printDocument.body.appendChild(toolbar);
    printDocument.body.appendChild(printRoot);

    printButton.addEventListener('click', function () {
      printWindow.focus();
      printWindow.print();
    });

    closeButton.addEventListener('click', function () {
      printWindow.close();
    });

    const imagePromises = waitForPrintImages(printDocument);
    const fontPromise =
      printDocument.fonts && printDocument.fonts.ready
        ? printDocument.fonts.ready.catch(function () {})
        : Promise.resolve();

    let ready = false;

    const enablePrint = function () {
      if (ready) return;

      ready = true;
      printButton.disabled = false;
      printButton.textContent = 'Imprimer ou enregistrer en PDF';
      status.textContent =
        'Le contrat est prêt. Sur iPhone, vous pouvez aussi utiliser Partager puis Imprimer.';
      printWindow.focus();
    };

    Promise.all(stylePromises.concat(imagePromises, [fontPromise]))
      .then(enablePrint)
      .catch(enablePrint);

    /*
     * Sécurité : le bouton devient utilisable même si une feuille de style
     * externe ne signale jamais correctement son chargement.
     */
    window.setTimeout(enablePrint, 3000);
  }

  function initContrat() {
    initContratActions();
    initContratOptions();
    initContratFields();
    initCompletedFields();
    initExclusiveChoices();
    initConditionalFields();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContrat);
  } else {
    initContrat();
  }

  document.addEventListener('shopify:section:load', initContrat);
})();
